jQuery(document).ready(function () {
  var $ = jQuery;

  function mapTimeToSelectVal(time) {
    if (!time) return "";
    time = String(time).toLowerCase().trim();
    
    if (time.indexOf("1") === 0 && time.indexOf("month") > -1) return "1 month";
    if (time.indexOf("3") === 0 && time.indexOf("month") > -1) return "3 months";
    if (time.indexOf("6") === 0 && time.indexOf("month") > -1) return "6 months";
    
    return "3 months"; // default
  }

  function mapSelectValToTime(val) {
    if (!val) return "";
    val = String(val).toLowerCase().trim();
    
    return val;
  }

  function syncDeliveryFromVariant(time) {
    var $sel = $("#delivery");
    if (!$sel.length) return;
    
    var val = mapTimeToSelectVal(time);
    if (!val) return;
    
    if ($sel.val() !== val) {
      $sel.val(val);
    }
  }

  function getLinkForVariantAndDelivery($variant) {
    if (!$variant || !$variant.length) return "";
    
    var deliveryVal = $("#delivery").val();
    var url = "";
    
    if (deliveryVal === "1 month") {
      url = $variant.data("link-1m");
    } else if (deliveryVal === "3 months") {
      url = $variant.data("link-3m");
    } else if (deliveryVal === "6 months") {
      url = $variant.data("link-6m");
    }
    
    return url || "";
  }

  // Function to clear cart via AJAX before adding new item
  function clearCartAndRedirect(url) {
    // First, get the cart token
    fetch("https://www.aniforte.co.uk/cart.js")
      .then(response => response.json())
      .then(cart => {
        if (cart.items && cart.items.length > 0) {
          // Clear all items from cart
          return fetch("https://www.aniforte.co.uk/cart/clear.js", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({})
          });
        }
        return Promise.resolve();
      })
      .then(() => {
        // After clearing, redirect to the new product URL
        window.location.href = url;
      })
      .catch(error => {
        console.error("Error clearing cart:", error);
        // If error, still try to redirect
        window.location.href = url;
      });
  }

  function setupCartButton($button, url) {
    if (!$button.length || !url) return;
    
    $button.off("click.cartHandler").on("click.cartHandler", function(e) {
      e.preventDefault();
      e.stopPropagation();
      
      // Clear cart first, then add new product
      clearCartAndRedirect(url);
      
      return false;
    });
  }

  function updateSubscribeCartLink() {
    var $activeVariant = $(".subscribe_save .variant.active").first();
    if (!$activeVariant.length) return;
    
    var href = getLinkForVariantAndDelivery($activeVariant);
    if (href) {
      setupCartButton($(".to_cart"), href);
    }
  }

  function updateOneTimeCartLink() {
    var $activeVariant = $(".one_time_purchase .variant.active").first();
    if (!$activeVariant.length) return;
    
    var href = $activeVariant.data("link");
    if (href) {
      if (href.startsWith("/cart/")) {
        href = "https://www.aniforte.co.uk" + href;
      }
      setupCartButton($(".to_cart"), href);
    }
  }

  $(".purchase-variation .title").click(function () {
    var $content = $(this).next(".purchase-variation .content");
    if (!$content.hasClass("active")) {
      $(".purchase-variation .content.active").removeClass("active").css("max-height", 0);
      $(".purchase-variation .title.active").removeClass("active");
      $content.addClass("active").css("max-height", $content[0].scrollHeight);
      $(this).addClass("active");
    }
  });

  $(".flavor-item").on("click", function () {
    $(".flavor-item").removeClass("active");
    $(this).addClass("active");
  });

  $(".flavor-item.flavor1").on("click", function () {
    if ($(".one_time_purchase").hasClass("active")) {
      var dataLink = $(".one_time_purchase").find(".variant.active").data("link");
      var dataOffer = $(".one_time_purchase").find(".variant.active").data("offer");
      $(".dop-text").text(dataOffer);
      updateOneTimeCartLink();
    }
    
    if ($(".subscribe_save").hasClass("active")) {
      var dataLink = $(".subscribe_save").find(".variant.active").data("link-3m");
      var dataOffer = $(".subscribe_save").find(".variant.active").data("offer");
      $(".dop-text").text(dataOffer);
      updateSubscribeCartLink();
    }
  });

  $(".flavor-item.flavor2").on("click", function () {
    if ($(".one_time_purchase").hasClass("active")) {
      var dataLink2 = $(".one_time_purchase").find(".variant.active").data("link2");
      var dataOffer = $(".one_time_purchase").find(".variant.active").data("offer");
      $(".dop-text").text(dataOffer);
      updateOneTimeCartLink();
    }
    
    if ($(".subscribe_save").hasClass("active")) {
      var dataLink2 = $(".subscribe_save").find(".variant.active").data("link2");
      var dataOffer = $(".subscribe_save").find(".variant.active").data("offer");
      $(".dop-text").text(dataOffer);
      updateSubscribeCartLink();
    }
  });

  $(".variation-item").on("click", function () {
    $(".variation-item").removeClass("active");
    $(this).addClass("active");
    
    if ($(this).hasClass("one_time_purchase")) {
      updateOneTimeCartLink();
    } else if ($(this).hasClass("subscribe_save")) {
      updateSubscribeCartLink();
    }
  });

  $(".one_time_purchase")
    .find(".title")
    .on("click", function () {
      $(".benefits").removeClass("active");
      $(".dop-text").css("display", "none");
      
      var dataLink = $(".one_time_purchase").find(".variant.active").data("link");
      var dataLink2 = $(".one_time_purchase").find(".variant.active").data("link2");
      var dataOffer = $(".one_time_purchase").find(".variant.active").data("offer");
      var dataPriceOld = $(".one_time_purchase").find(".variant.active").data("old");
      var dataPrice = $(".one_time_purchase").find(".variant.active").data("new");
      $("#original-price").text(dataPriceOld);
      $("#current-price").text(dataPrice);
      
      if ($(".flavor-item.flavor1").hasClass("active")) {
        if ($(".one_time_purchase .content").hasClass("active")) {
          $(".dop-text").text(dataOffer);
          updateOneTimeCartLink();
        }
      }
      
      if ($(".flavor-item.flavor2").hasClass("active")) {
        if ($(".one_time_purchase .content").hasClass("active")) {
          $(".dop-text").text(dataOffer);
          updateOneTimeCartLink();
        }
      }
    });

  $(".one_time_purchase .variant").on("click", function () {
    var dataLink = $(this).data("link");
    var dataLink2 = $(this).data("link2");
    var dataOffer = $(this).data("offer");
    var dataPriceOld = $(this).data("old");
    var dataPrice = $(this).data("new");
    
    $(".one_time_purchase .variant").removeClass("active");
    $(this).addClass("active");
    
    $("#original-price").text(dataPriceOld);
    $("#current-price").text(dataPrice);
    
    if ($(".flavor-item.flavor1").hasClass("active")) {
      $(".dop-text").text(dataOffer);
      updateOneTimeCartLink();
    }
    
    if ($(".flavor-item.flavor2").hasClass("active")) {
      $(".dop-text").text(dataOffer);
      updateOneTimeCartLink();
    }
    
    $(".dop-text").css("display", "none");
  });

  $(document).on("click", ".subscribe_save .title", function () {
    $(".benefits").addClass("active");
    $(".dop-text").css("display", "block");
    
    var $active = $(".subscribe_save .variant.active").first();
    if (!$active.length) {
      $active = $(".subscribe_save .variant").first().addClass("active");
    }
    
    var dataOffer    = $active.data("offer");
    var dataPriceOld = $active.data("old");
    var dataPrice    = $active.data("new");
    var time         = $active.data("time");
    
    if (dataOffer) {
      $(".dop-text").text(dataOffer);
    }
    if (dataPriceOld) {
      $("#original-price").text(dataPriceOld);
    }
    if (dataPrice) {
      $("#current-price").text(dataPrice);
    }
    
    syncDeliveryFromVariant(time);
    updateSubscribeCartLink();
  });

  $(document).on("click", ".subscribe_save .variant", function () {
    var $this = $(this);
    
    var sale        = $this.data("sale");
    var time        = $this.data("time");
    var dataOffer   = $this.data("offer");
    var dataPriceOld= $this.data("old");
    var dataPrice   = $this.data("new");
    
    $(".subscribe_save .variant").removeClass("active");
    $this.addClass("active");
    
    if (sale !== undefined) {
      $(".sale p span").text(sale);
    }
    if (time) {
      $(".month p span").text(time);
    }
    if (dataOffer) {
      $(".dop-text").css("display", "block").text(dataOffer);
    }
    
    if (dataPriceOld) {
      $("#original-price").text(dataPriceOld);
    }
    if (dataPrice) {
      $("#current-price").text(dataPrice);
    }
    
    syncDeliveryFromVariant(time);
    updateSubscribeCartLink();
  });

  $("#delivery").on("change", function () {
    var time = mapSelectValToTime($(this).val());
    if (time) {
      $(".month p span").text(time);
      
      var $activeVariant = $(".subscribe_save .variant.active").first();
      if ($activeVariant.length) {
        var offerText = "DELIVERED EVERY " + time.toUpperCase();
        $(".dop-text").text(offerText);
      }
    }
    
    updateSubscribeCartLink();
  });

  // Initialize default variants
  (function initDefaultVariants() {
    // STEP 1: Make sure Subscribe & Save is the active variation tab
    $(".variation-item").removeClass("active");
    $(".subscribe_save").addClass("active");
    $(".one_time_purchase").removeClass("active");
    
    // STEP 2: Show Subscribe content, hide One-Time content
    $(".purchase-variation .content.active").removeClass("active").css("max-height", 0);
    $(".subscribe_save .content").addClass("active").css("max-height", $(".subscribe_save .content")[0].scrollHeight);
    
    // STEP 3: Initialize Subscribe & Save default (Three Pack - 3 months)
    var $defaultSubscribeVar = $(".subscribe_save .variant").filter(function () {
      var time = String($(this).data("time")).toLowerCase().trim();
      return time === "3 month" || time === "3 months";
    }).first();
    
    if ($defaultSubscribeVar.length) {
      $(".subscribe_save .variant").removeClass("active");
      $defaultSubscribeVar.addClass("active");
      
      $("#delivery").val("3 months");
      
      var sale        = $defaultSubscribeVar.data("sale");
      var time        = $defaultSubscribeVar.data("time");
      var dataOffer   = $defaultSubscribeVar.data("offer");
      var dataPriceOld= $defaultSubscribeVar.data("old");
      var dataPrice   = $defaultSubscribeVar.data("new");
      
      if (sale !== undefined) $(".sale p span").text(sale);
      if (time) $(".month p span").text(time);
      if (dataOffer) $(".dop-text").css("display", "block").text(dataOffer);
      if (dataPriceOld) $("#original-price").text(dataPriceOld);
      if (dataPrice) $("#current-price").text(dataPrice);
      
      // STEP 4: Set the button for Subscribe & Save
      updateSubscribeCartLink();
    } else {
      console.warn("Default Subscribe variant with data-time='3 month' not found");
    }
    
    // STEP 5: Initialize One-Time Purchase default (but don't activate it)
    var $defaultOneTimeVar = $(".one_time_purchase .variant.active").first();
    if (!$defaultOneTimeVar.length) {
      // Set first One-Time variant as active but keep it hidden
      $(".one_time_purchase .variant").first().addClass("active");
    }
  })();
});

jQuery(window).resize(function () {
  var $ = jQuery;
});

jQuery(window).scroll(function () {
  var $ = jQuery;
});